"use client";

import { useAuthExpiredStore } from "@/contexts/auth-expired-store";
import { Modal } from "antd";
import { useUser } from "@/hooks/use-user";
import { usePathname } from "next/navigation";
import { useMemo } from "react";

// AuthExpiredModal component
export function AuthExpiredModal() {
  const { isExpired } = useAuthExpiredStore();
  const pathname = usePathname();
  const { signOut, user } = useUser();

  const showModal = useMemo(() => {
    return isExpired && !pathname.startsWith("/auth") && !!user;
  }, [isExpired, pathname, user]);

  const handleOk = () => {
    signOut();
  };

  if (!showModal) return null;
  return (
    <Modal
      title="Session expired"
      open={isExpired}
      onOk={handleOk}
      onCancel={handleOk}
      okText="Back"
      cancelText="Cancel"
      maskClosable={false}
    >
      <p>Your session has expired. Please sign in again.</p>
    </Modal>
  );
}
